import { RadioGroup } from "@radix-ui/react-dropdown-menu";
import { ForwardedRef, forwardRef } from "react";
import { FieldPath, FieldValues } from "react-hook-form";
import { Radio } from "../forms/radio";
import { FormField, TFormField } from "./form-field";

interface RadioGroupFormFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TFieldPath extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> extends TFormField<TFieldValues, TFieldPath> {
  options: RadioOption<string>[];
}

export interface RadioOption<TValue = string> {
  label: string;
  value: TValue;
  disabled?: boolean;
}

export const RadioGroupFormField = forwardRef(function RadioGroupFormField<
  TFieldValues extends FieldValues = FieldValues,
  TFieldPath extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  { options, ...props }: RadioGroupFormFieldProps<TFieldValues, TFieldPath>,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return (
    <FormField {...props}>
      {(field) => (
        <RadioGroup ref={ref} role="radiogroup" {...field}>
          {options.map((option) => (
            <label
              key={`${option.label}-${option.value}`}
              className="flex items-center gap-1"
            >
              <Radio
                aria-label={field.name}
                name={field.name}
                value={option.value}
                required={field.required}
                disabled={field.disabled || option.disabled || false}
              />
              {option.label}
            </label>
          ))}
        </RadioGroup>
      )}
    </FormField>
  );
});
